import { Navigate } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';
import { Loader2 } from 'lucide-react';

interface Props {
  children: React.ReactNode;
}

/**
 * Gates the /intern route to users with role 'intern', 'owner', or 'super_admin'.
 * Must be placed inside ProtectedRoute (which handles the basic auth check).
 */
export function InternProtectedRoute({ children }: Props) {
  const { userProfile, loading } = usePermissions();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--color-warm-white)]">
        <Loader2 className="h-8 w-8 animate-spin text-[var(--color-forest)]" />
      </div>
    );
  }

  const role = userProfile?.role;
  const allowed = role === 'intern' || role === 'owner' || role === 'super_admin';

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
